




import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator';

@Component
export default class IntegrationIcon extends Vue {
  @Prop() private integrationType!: string;
  @Prop() private size?: number;
  @Prop() private minHeight?: number;
  @Prop() private color?: string;
  @Prop() private disabled?: boolean;

  private readonly fontBasedIcons: string[] = ['mysql-database', 'azure-sql-server'];

  private get useFont(): boolean {
    return !this.icon.endsWith('svg');
  }

  get icon() {
    switch ( this.integrationType ) {
      case 'email':
      case 'webhook':
      case 'websocket':
      case 'mqtt':
      case 'bacnet':
        return `/img/icons/integrations/${this.integrationType}.svg`;
      case 'awsiot':
        return '/img/icons/integrations/nodered.svg';
      case 'slack':
        return '/img/icons/integrations/slack.svg';
      case 'opsgenie':
        return '/img/icons/integrations/opsgenie.svg';
      case 'azure-sql-server':
      case 'mysql-database':
        return 'mdi-database';
      case 's3':
        return '/img/icons/integrations/s3-logo.svg';
      case 'qss3':
        return '/img/icons/integrations/amazon-quicksight.svg';
      case 'azure-blob':
        return '/img/icons/integrations/azure-storage-blob.svg';
      case 'azureDataLake':
        return '/img/icons/integrations/azure-data-lake.svg';
      case 'sftp':
        return '/img/icons/integrations/sftp.svg';
      default:
        return `mdi-power-plug`;
    }
  }
}
